import { FC, useEffect, useState } from 'react'
import { Counterparty } from 'entities/counterparties/model'
import { DetailOrder } from 'entities/orders/model'
import { DetailsPaymentsForm } from 'features/DetailsPayments/ui/DetailsPaymentsForm'
import { CheckoutPayments } from 'features/DetailsPayments/ui/CheckoutPayments'
import { CreateAccountPaymentRequest } from 'entities/payments/model'

export type AccountDetails = Omit<CreateAccountPaymentRequest, 'orderId' | 'comment' | 'amount' | 'paymentMethodId'>
export type onPaymentProcess = (details: AccountDetails) => void

export interface DetailsPaymentsModalProps {
    detailOrder: DetailOrder
    counterparty: Counterparty
    onPaymentProcess: onPaymentProcess
    details?: AccountDetails
    currentSelectedBookings?: any[]
}

interface SelectedBooking {
    booking_id: number
    area_hours: {
        count: number
    },
    nomenclatures?: {
        id: number
        count: number
    }[]
}

export const DetailsPaymentsModal: FC<DetailsPaymentsModalProps> = ({
    detailOrder,
    counterparty,
    onPaymentProcess,
    details,
}) => {
    
    const [selectedBookingsFromCheckout, setSelectedBookingsFromCheckout] = useState<SelectedBooking[]>([]);
    const [currentSelectedBookings, setCurrentSelectedBookings] = useState<any[]>([]);

    useEffect(() => {
        const transformedBookings = selectedBookingsFromCheckout.map((item) => ({
            id: item.booking_id,
            area_hours: item.area_hours.count,
            nomenclatures: item.nomenclatures
        }));
        
        setCurrentSelectedBookings(transformedBookings);
    }, [selectedBookingsFromCheckout])

    return (
        <div
            style={{
                display: 'grid',
                gridTemplateColumns: 'auto 483px',
                height: '100%',
                gap: 10,
                paddingBottom: "40px"
            }}
        >
            <DetailsPaymentsForm
                detailOrder={detailOrder}
                counterparty={counterparty}
                onPaymentProcess={onPaymentProcess}
                details={details}
                currentSelectedBookings={currentSelectedBookings}
            />
            <CheckoutPayments
                detailOrder={detailOrder}
                counterparty={counterparty}
                setSelectedBookingsFromCheckout={setSelectedBookingsFromCheckout}
            />
        </div>
    )
}
